import PropTypes from 'prop-types'
import React from 'react'
import Trans from 'next-translate/Trans'
import config from 'SRC/config/config.json'

export const Search = ({ packages }) => {
  const text = config.registrationForm.package.search
  return (
    <tr>
      <Trans
        i18nKey='common:packages_search_in_profile_text'
        components={{
          td: <td />,
          strong: <strong />
        }}
        defaultTrans='<td>Pretraga <strong>unutar profila</strong></td>'
      />
      {
        packages.map(item => <td key={item.id}>{<i className={`ico-${item.search ? `ima` : `nema`} ico`} />}</td>)
      }
    </tr>
  )
}
Search.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    search: PropTypes.bool
  })).isRequired
}

Search.defaultProps = {
  packages: []
}
